import type { FaireProductEntity } from "../../entity_types/product";

export const p_m93ms2ef9n: FaireProductEntity = {
  token: "p_m93ms2ef9n",
  type: "product",
  name: "Los Angeles Terroir Candle | Luxury Candle with 50 Hour Burn",
  brandToken: "b_2kekbkmu5g",
  brandName: "naomi",
  imageUrl:
    "https://cdn.faire.com/fastly/31cb5401f1d1671527dc5eb86fbd81ba123667f4fd7c21027535191702bf0225.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4f7a67034cb93baa1fbbb55f321c970cb668b13b1c65511ba0e351124105306e.png",
    "https://cdn.faire.com/fastly/c182a4315526df15da2f9c7e8d0b9d8df2ad9eb46e64d4a5b8db0322fb031339.png",
    "https://cdn.faire.com/fastly/0f651b38254a8cd3c9deb4eabbae75953b36cd6cc4d5cb07c53bffc1c3d80f60.png",
  ],
  priceDollars: 21,
  description:
    "Inspired by foraging in LA canyons, the Los Angeles Terroir candle is made with essential oils from plant species local to LA: white sage, cypress, yarrow, jasmine sambac, blood orange, and more. Think woody, crisp, and sunburnt green.\n\nHand-poured in Los Angeles. 10 oz, soy. Supporting World Central kitchen with 2% of sales providing chef-prepared meals to people in crisis.\n\nComes in cotton paper box with art from LA artist Thom Nguyen.",
  tags: [],
  msrpDollars: 39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:52.737Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
